import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { formatDate } from "@angular/common";
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, take, tap } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { RolesService } from "src/app/modules/roles/roles.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { PrintQrDialogComponent } from "src/app/shared/components/dialogs/print-qr-dialog/print-qr-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { Property } from "src/app/shared/models/property/property.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { CondoStructuresService } from "../../condo-structures.service";
import { DocumentArchivesService } from "../../document-archives.service";
import DocumentTypeStructure from "../../documentTypes";
var PropertyAddDocumentsComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyAddDocumentsComponent(configService, activatedRoute, propertiesService, router, toastrService, translateService, themeService, authService, dialog, cookieService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    condoStructuresService, rolesService, helperService, documentArchivesService, companiesService, suppliersService, settingsService) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.apiService = apiService;
        this.condoStructuresService = condoStructuresService;
        this.rolesService = rolesService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.companiesService = companiesService;
        this.suppliersService = suppliersService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.loggedUserRoleType = "";
        this.property = new Property();
        this.propertyId = "";
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.activeSectionData = [];
        this.allDocs = [];
        this.sortedDocuments = [];
        this.documentTypeStructure = new DocumentTypeStructure();
        this.documentArchiveIsLoading = true;
        this.showDocumentsExpired = true;
        this.insertDocuments = true;
        this.insertDocumentsSelected = false;
        this.insertDocumentsSelectedKey = [];
        this.company = new Company();
        this.pageIsLoading = true;
        this.unitaImmobiliari = false;
        this.step0 = true;
        this.step1 = false;
        this.step2 = false;
        // bntStep1 = false;
        this.docsSelected = [];
        this.structureSelected = [];
        this.selectedStructureFree = "";
        this.canSubmitForm = true;
        this.dataIsLoading = false;
        this.docTopics = [];
        this.docSubTopics = [];
        // BEGIN - Edit item form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.printModuleBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printModule"),
            spinnerSize: 19,
            raised: false,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-print",
                inline: true,
            },
        };
        this.printQrBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.printLabel"),
            spinnerSize: 19,
            raised: false,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "accent",
            spinnerColor: "accent",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-qrcode",
                inline: true,
            },
        };
        // END - Edit item form
        this.dataSaved = false;
        this.previousDocTypes = [];
        this.docUploaded = false;
        this.selectedSubTopics = []; // used for displaying topic titles (AA: Dipendenti ecc...)
        this.checkboxesAreSelected = false;
        this.searchValue = "";
        this.subscriptionType = "FREE";
        this.editDocument = true;
        this.barCode = "";
        this.contratti = false;
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.mappaturaOpen = false;
        this.isIncendioEvac = false;
        this.isSicurezzaAntincendioFacciate = false;
        this.masterAndSubscriptionPrivacy = false;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.addDocumentsPage.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = currentRole.role.type;
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        this.loggedUserRole = this.currentRole.role;
        this.loggedUserMaster =
            this.loggedUserRole.type === "master" ||
                this.loggedUserRole.type === "collaborator";
        this.loggedUserAdmin =
            this.loggedUserRole.type === "admin" ||
                this.loggedUserRole.type === "operator";
        // Only admins/operators can choose between digital/paper documents
        if (this.loggedUserMaster) {
            this.docType = "digital";
        }
        // this.subscriptions.push(
        //   this.rolesService
        //     .get(this.authService.loggedUserRequestedRole$.getValue())
        //     .subscribe(res2 => {
        //       if (res2.status) {
        //         this.loggedUserRole = res2.role;
        //         this.loggedUserMaster =
        //           this.loggedUserRole.type === "master" ||
        //           this.loggedUserRole.type === "collaborator";
        //         // Only admins/operators can choose between digital/paper documents
        //         if (this.loggedUserMaster) {
        //           this.docType = "digital";
        //         }
        //       }
        //     })
        // );
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                }
            }
        }, function (err) {
            //
        }));
        // Get requested property data, company data and document archive
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
            if (res.status) {
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                if (_this.propertyData &&
                    _this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.subscriptionType === 'PRIVACY' && _this.loggedUserMaster) {
                        _this.masterAndSubscriptionPrivacy = true;
                    }
                }
                if (_this.propertyData.admin &&
                    _this.propertyData.admin.company &&
                    _this.propertyData.admin.company._id) {
                    _this.subscriptions.push(_this.companiesService
                        .get(_this.propertyData.admin.company._id)
                        .subscribe(function (res) {
                        if (res.status) {
                            _this.company.setData(res.data);
                        }
                    }));
                }
                // If property has a structure ID, than retrive related data
                // and document archive
                if (_this.subscriptionType !== "FREE" &&
                    _this.subscriptionType !== "FREEBASIC" &&
                    _this.propertyData.structure) {
                    _this.getStructureData();
                }
                else {
                    if (_this.propertyData.documentArchive) {
                        _this.documentArchiveId = _this.propertyData.documentArchive;
                        _this.getDocumentArchiveData();
                    }
                    _this.documentArchiveIsLoading = false;
                    _this.pageIsLoading = false;
                }
                // Calculate property's barCode - just for Paper doc
                var total = (+_this.propertyData.totalDocsProgressive + 1).toString();
                _this.barCode = _this.propertyData._id + "S" + total.padStart(6, "0") + "C";
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Get current property structure data and populate
     * this.condoStructure.
     * Then get archive document.
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.getStructureData = function () {
        var _this = this;
        this.condoStructuresService
            .get(this.property.get("structure"))
            .subscribe(function (res) {
            if (res.status) {
                _this.condoStructure = res.data;
                _this.mappaturaOpen = _this.condoStructure.open;
                if (_this.condoStructure.open && _this.subscriptionType !== "FREE" && _this.subscriptionType !== "FREEBASIC") {
                    _this.editDocument = false;
                }
                // If property has a document Archive ID, than retrive related data
                if (_this.propertyData.documentArchive) {
                    _this.documentArchiveId = _this.propertyData.documentArchive;
                    _this.getDocumentArchiveData();
                }
            }
            else {
                _this.documentArchiveIsLoading = false;
                _this.pageIsLoading = false;
                _this.toastrService.error(res.message);
            }
        });
    };
    /**
     * Get current property documentArchive data and populate
     * this.documentArchive
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.getDocumentArchiveData = function () {
        var _this = this;
        this.documentArchivesService
            .get(this.property.get("documentArchive"))
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                _this.documentArchiveIsLoading = false;
                _this.pageIsLoading = false;
                _this.setVisibleDocsByStructures();
                if (_this.documentArchive.suppliersName) {
                    _this.suppliersName = _this.documentArchive.suppliersName;
                }
                if (_this.documentArchive.yearsOfStorage) {
                    _this.yearsOfStorage = _this.documentArchive.yearsOfStorage;
                }
                if (_this.documentArchive.conductorName) {
                    _this.conductorName = _this.documentArchive.conductorName;
                }
                if (_this.documentArchive.nameInterventionArchiving) {
                    _this.nameInterventionArchiving =
                        _this.documentArchive.nameInterventionArchiving;
                }
            }
            else {
                _this.documentArchiveIsLoading = false;
                _this.pageIsLoading = false;
                _this.toastrService.error(res.message);
            }
        });
    };
    /**
     * Init form basing on docType
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onChooseDocType = function (type) {
        this.docType = type;
        // setTimeout(() => {
        //   if (
        //     this.docType === 'digital'
        //     && (this.data.action === 'new' || this.data.action === 'edit')
        //   ) {
        //     this.watchFileChanges();
        //   }
        // }, 500);
    };
    /**
     * Watch for file-uploader changes, if file was uploaded
     * scroll down on dialog bottom
     *
     * @since 1.0.0
     */
    // watchFileChanges(): void {
    //   if (this.form.controls["documentFile"]) {
    //     this.subscriptions.push(
    //       this.form.controls["documentFile"].valueChanges.subscribe(
    //         res => {
    //           // A file was uploaded, scroll down dialog
    //           if (Array.isArray(res) && res.length) {
    //             const dialogWindow = document.getElementsByTagName("mat-dialog-container")[0]; // assuming we can have only one dialog opened
    //             if (dialogWindow) {
    //               const contentToScroll = dialogWindow.getElementsByClassName("mat-dialog-content");
    //               if (contentToScroll[0]) {
    //                 const bottomHeight = contentToScroll[0].scrollHeight;
    //                 contentToScroll[0].scrollTo({
    //                   top: bottomHeight,
    //                   behavior: "smooth",
    //                 });
    //               }
    //             }
    //           }
    //         },
    //         err => {
    //           this.helperService.handleError(err);
    //         }
    //       ));
    //   }
    // }
    /**
     * Get selected area of documents
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onChangeArea = function ($event) {
        var area = this.selectedArea ? this.selectedArea.toString() : undefined;
        this.docArea = undefined;
        var docArea;
        if ($event.source.name === "radioArea") {
            // Get selected area children (es: A, B...)
            docArea = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentArea2(area, this.documentTemplate)));
            this.setVisibleDocsByStructures();
        }
        if (this.masterAndSubscriptionPrivacy) {
            if (Array.isArray(docArea.content)) {
                docArea.content = docArea.content.filter(function (el) { return el.title === "properties.documents.gestionaleAmministrativo"; });
                docArea.content.forEach(function (el) {
                    if (Array.isArray(el.content)) {
                        el.content = el.content.filter(function (subEl) {
                            return subEl.title === "properties.documents.Aprivacy" ||
                                subEl.title === "properties.documents.gestAmmTivoDipendenti" ||
                                subEl.title === "properties.documents.gestAmmTivoGestionali";
                        });
                    }
                });
            }
        }
        this.docArea = docArea;
        this.dataIsLoading = false;
        // Reset children
        this.docTopics = [];
        this.docSubTopics = [];
        this.selectedSubTopics = [];
        this.docsSelected = [];
        this.checkboxesAreSelected = false;
    };
    /**
     * Handle select subdocuments
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onChangeTopic = function (code, checked) {
        if (checked) {
            // Get selected topic children (es: AA, AB...)
            this.docTopics = tslib_1.__spread(this.docTopics, JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentTopic2(code, this.documentTemplate, this.condoStructure))));
            if (this.docTopics[0].rawTitle === "contratti") {
                this.contratti = true;
            }
            else {
                this.contratti = false;
            }
            // Only Privacy
            if (this.subscriptionType === 'PRIVACY' &&
                !this.loggedUserAdmin) {
                this.docTopics = this.docTopics.filter(function (el) {
                    return el.title === "properties.documents.Aprivacy" ||
                        el.title === "properties.documents.gestAmmTivoDipendenti" ||
                        el.title === "properties.documents.gestAmmTivoGestionali";
                });
            }
            // Filter on "incendioEvac" and "sicurezzaAntincendioFacciate"
            // if (!this.isIncendioEvac) { 
            //   this.docTopics = this.docTopics.filter(
            //     (el: any) => el.rawTitle !== "incendioEvac"); 
            // }
            if (!this.isSicurezzaAntincendioFacciate) {
                this.docTopics = this.docTopics.filter(function (el) { return el.rawTitle !== "sicurezzaAntincendioFacciate"; });
            }
        }
        else {
            this.docTopics = this.docTopics.filter(function (doc) { return doc.parent !== code; });
            this.selectedSubTopics = this.selectedSubTopics.filter(function (subTopic) { return subTopic.parent !== code; });
            // Leave only items with same parent as the remaining selectedSubTopics
            var selectedCodes_1 = this.selectedSubTopics.map(function (el) { return el.code; });
            this.docSubTopics = this.docSubTopics.filter(function (subDoc) {
                return selectedCodes_1.includes(subDoc.parent);
            });
            // If no checkbox is selected, set acceptedType to undefined
            // This makes all checkboxes enabled
            if (this.docSubTopics.every(function (el) { return !el.value; }) ||
                !this.selectedSubTopics.length) {
                this.acceptedType = undefined;
                this.checkboxesAreSelected = false;
            }
        }
    };
    /**
     * Handle select subdocuments
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onChangeSubTopic = function (subTopic, checked, parentCode) {
        if (!subTopic) {
            this.toastrService.error("No subTopics injected");
            return;
        }
        var subscriptionFree = false;
        if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
            subscriptionFree = true;
        }
        if (checked) {
            // Get selected subTopic children (es: AA1, AA2...)
            var docSubTopics = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentSubTopic2(subTopic.code, parentCode, this.documentTemplate, this.condoStructure, subscriptionFree, this.lang)));
            if (this.contratti && this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
                this.contratti = true;
            }
            docSubTopics = docSubTopics.filter(function (el) { return !el.deleted; });
            // Only Privacy
            if (this.subscriptionType === 'PRIVACY' &&
                !this.loggedUserAdmin) {
                docSubTopics = docSubTopics.filter(function (el) { return el.privacy; });
            }
            this.docSubTopics = tslib_1.__spread(this.docSubTopics, docSubTopics);
            // Add to displayed array
            this.selectedSubTopics.push(subTopic);
        }
        else if (!checked) {
            // Remove from arrays
            this.docSubTopics = this.docSubTopics.filter(function (doc) { return doc.parent !== subTopic.code; });
            var index = this.selectedSubTopics
                .map(function (el) { return el.code; })
                .indexOf(subTopic.code);
            this.selectedSubTopics.splice(index, 1);
        }
        // Eliminate duplicates
        this.docSubTopics = this.docSubTopics.filter(function (topic, index, self) {
            return self.findIndex(function (t) { return t.code === topic.code; }) === index;
        });
        // If no checkbox is selected, set acceptedType to undefined
        if (this.docSubTopics.every(function (el) { return !el.value; }) ||
            !this.selectedSubTopics.length) {
            this.acceptedType = undefined;
            this.checkboxesAreSelected = false;
        }
        // Sort displayed data in alphabetical order
        this.selectedSubTopics.sort(function (a, b) { return a.code.localeCompare(b.code); });
    };
    /**
     * Handle enable same docs type
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onSetSubDoc = function (code, checked) {
        var _this = this;
        var type = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentType2(code, this.documentTemplate)));
        if (checked) {
            this.acceptedType = type;
        }
        // set this if at least one checkbox is selected
        this.checkboxesAreSelected = false;
        this.docSubTopics.forEach(function (el) {
            var subType = JSON.parse(JSON.stringify(_this.documentTypeStructure.getDocumentType2(el.code, _this.documentTemplate)));
            if (!checked) {
                // If the unchecked item is the only one with this type, remove acceptedType
                if (!el.value) {
                    _this.acceptedType === undefined;
                }
                if (el.code !== code && el.value) {
                    _this.checkboxesAreSelected = true;
                }
            }
            else {
                _this.checkboxesAreSelected = true;
            }
        });
    };
    /**
     * Handle filter on docs
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.applyFilter = function (event) {
        this.searchValue = event.target.value;
        var regex = new RegExp(this.searchValue.trim().toLowerCase(), "gi");
        this.docSubTopics.forEach(function (el) {
            if ((el.title && el.title.search(regex) > -1) ||
                el.code.search(regex) > -1) {
                el.visible = true;
            }
            else {
                el.visible = false;
                el.value = false;
            }
        });
    };
    /**
     * Handle go back to initial step
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onStep0 = function () {
        this.step0 = true;
        this.step1 = false;
        if (!this.docUploaded) {
            // If documents were not uploaded yet, reinit form
            // this.initPropertyForm();
            this.docsSelected = [];
            return;
        }
        else {
            // Documents uploaded: reset data
        }
    };
    /**
     * Handle step insert data
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onStep1 = function () {
        var _this = this;
        // Return if button is disabled
        if (!this.checkboxesAreSelected) {
            return;
        }
        this.step0 = false;
        this.step1 = true;
        var key = "";
        var schemaType = "";
        this.structureSelected = [];
        var contractStructures = [];
        if (this.contratti) {
            if (this.subscriptionType !== "FREE" && this.subscriptionType !== "FREEBASIC") {
                this.docSubTopics.forEach(function (subEl) {
                    var e_1, _a;
                    contractStructures = [];
                    if (subEl.value) {
                        key = subEl.code;
                        schemaType = subEl.schemaType;
                        if (subEl.origin) {
                            var _loop_1 = function (docs) {
                                if (!docs.deleted) {
                                    var content = docs.content;
                                    if (content && Array.isArray(content)) {
                                        var index = -1;
                                        if (subEl.origin === "impelegenerale-contratti") {
                                            index = content.findIndex(function (subDocs) {
                                                return (subDocs.title.replace("properties.documents.", "") ===
                                                    "impelegenerale");
                                            });
                                        }
                                        else if (subEl.origin === "impeleMediaTensione-contratti") {
                                            index = content.findIndex(function (subDocs) {
                                                return (subDocs.title.replace("properties.documents.", "") ===
                                                    "impeleMediaTensione");
                                            });
                                        }
                                        else {
                                            index = content.findIndex(function (subDocs) {
                                                return (subDocs.title.replace("properties.documents.", "") ===
                                                    subEl.origin);
                                            });
                                        }
                                        if (index > -1) {
                                            var structure_1 = "";
                                            if (subEl.origin === "impelegenerale-contratti") {
                                                structure_1 = "fornituraBt";
                                            }
                                            else if (subEl.origin === "impeleMediaTensione-contratti") {
                                                structure_1 = "fornituraMt";
                                            }
                                            else {
                                                structure_1 = content[index].structure;
                                            }
                                            if (structure_1 && structure_1 !== "") {
                                                contractStructures = [];
                                                _this.condoStructure[structure_1].forEach(function (item) {
                                                    if (typeof item.active !== "undefined" &&
                                                        item.active) {
                                                        switch (structure_1) {
                                                            case "fornituraBt":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.codicePod,
                                                                    value: false,
                                                                    type: "fornituraBt",
                                                                });
                                                                break;
                                                            case "fornituraMt":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.numeroContrattofornitur,
                                                                    value: false,
                                                                    type: "fornituraMt",
                                                                });
                                                                break;
                                                            // case "estintori":
                                                            //   contractStructures.push({
                                                            //     id: item._id,
                                                            //     name: "Estintori", // item.nome,
                                                            //     value: false,
                                                            //     type: "estintori",
                                                            //   });
                                                            //   break;
                                                            case "contatoriAcqua":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.codiceUtente,
                                                                    value: false,
                                                                    type: "contatoriAcqua",
                                                                });
                                                                break;
                                                            case "contatoreGas":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.codicePdr,
                                                                    value: false,
                                                                    type: "contatoreGas",
                                                                });
                                                                break;
                                                            case "ascensore":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.numeroMatricola,
                                                                    value: false,
                                                                    type: "ascensore",
                                                                });
                                                                break;
                                                            case "montauto":
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome + " - " + item.numeroMatricola,
                                                                    value: false,
                                                                    type: "montauto",
                                                                });
                                                                break;
                                                            default:
                                                                contractStructures.push({
                                                                    id: item._id,
                                                                    name: item.nome,
                                                                    value: false,
                                                                    type: structure_1,
                                                                });
                                                        }
                                                    }
                                                });
                                            }
                                            return "break";
                                        }
                                    }
                                }
                            };
                            try {
                                // Get structures
                                for (var _b = tslib_1.__values(_this.documentTemplate), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var docs = _c.value;
                                    var state_1 = _loop_1(docs);
                                    if (state_1 === "break")
                                        break;
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            if (subEl.origin === "impelegenerale-contratti" ||
                                subEl.origin === "impeleMediaTensione-contratti") {
                                _this.docsSelected.push({
                                    subDoc: "contratti",
                                    subAreaTitle: subEl.subAreaTitle,
                                    title: subEl.title,
                                    key: subEl.code,
                                    schemaType: subEl.schemaType,
                                    structureSelected: contractStructures,
                                });
                            }
                            else {
                                _this.docsSelected.push({
                                    subDoc: subEl.origin,
                                    subAreaTitle: subEl.subAreaTitle,
                                    title: subEl.title,
                                    key: subEl.code,
                                    schemaType: subEl.schemaType,
                                    structureSelected: contractStructures,
                                });
                            }
                        }
                        else {
                            _this.docsSelected.push({
                                subDoc: "contratti",
                                subAreaTitle: subEl.subAreaTitle,
                                title: subEl.title,
                                key: subEl.code,
                                schemaType: subEl.schemaType,
                                structureSelected: [],
                            });
                        }
                        if (contractStructures.length) {
                            contractStructures.forEach(function (el) {
                                var structure = {
                                    id: el.id,
                                    name: el.name,
                                    value: false,
                                    type: el.type,
                                };
                                _this.structureSelected.push(structure);
                            });
                        }
                    }
                });
            }
            else {
                this.docSubTopics.forEach(function (subEl) {
                    contractStructures = [];
                    if (subEl.value) {
                        key = subEl.code;
                        schemaType = subEl.schemaType;
                        if (subEl.origin) {
                            if (subEl.origin === "impelegenerale-contratti" ||
                                subEl.origin === "impeleMediaTensione-contratti") {
                                _this.docsSelected.push({
                                    subDoc: "contratti",
                                    subAreaTitle: subEl.subAreaTitle,
                                    title: subEl.title,
                                    key: subEl.code,
                                    schemaType: subEl.schemaType,
                                    structureSelected: contractStructures,
                                });
                            }
                            else {
                                _this.docsSelected.push({
                                    subDoc: subEl.origin,
                                    subAreaTitle: subEl.subAreaTitle,
                                    title: subEl.title,
                                    key: subEl.code,
                                    schemaType: subEl.schemaType,
                                    structureSelected: contractStructures,
                                });
                            }
                        }
                        else {
                            _this.docsSelected.push({
                                subDoc: "contratti",
                                subAreaTitle: subEl.subAreaTitle,
                                title: subEl.title,
                                key: subEl.code,
                                schemaType: subEl.schemaType,
                                structureSelected: [],
                            });
                        }
                    }
                });
                this.selectedStructureFree = "-1";
            }
        }
        else {
            this.docTopics.forEach(function (el) {
                var structures = false;
                _this.docSubTopics.forEach(function (subEl) {
                    var e_2, _a;
                    // If element was selected and belongs to parent
                    if (subEl.parent === el.code && subEl.value) {
                        // Prevent entering duplicates
                        key = subEl.code;
                        schemaType = subEl.schemaType;
                        var keys = _this.docsSelected.map(function (el) { return el.key; });
                        if (keys.includes(key)) {
                            return;
                        }
                        var title_1 = el.title.replace("properties.documents.", "");
                        if (_this.subscriptionType !== "FREE" && _this.subscriptionType !== "FREEBASIC") {
                            var _loop_2 = function (docs) {
                                var e_3, _a;
                                if (!docs.deleted) {
                                    var content = docs.content;
                                    if (content && Array.isArray(content)) {
                                        var index = content.findIndex(function (subDocs) {
                                            return (subDocs.title.replace("properties.documents.", "") === title_1);
                                        });
                                        if (index > -1) {
                                            var structure_2 = "";
                                            if (title_1 === "incendioEvac") {
                                                structure_2 = "evac";
                                            }
                                            else {
                                                structure_2 = content[index].structure;
                                            }
                                            if (structure_2 && structure_2 !== "") {
                                                _this.condoStructure[structure_2].forEach(function (item) {
                                                    if (typeof item.active !== "undefined" &&
                                                        item.active) {
                                                        var ids = _this.structureSelected.map(function (el) { return el.id; });
                                                        var name_1 = item.nome;
                                                        switch (structure_2) {
                                                            case "dipendenti":
                                                                name_1 = item.nome + " " + item.cognome;
                                                                break;
                                                            case "contatoreGas":
                                                                name_1 = item.nome + " - " + item.codicePdr;
                                                                break;
                                                            case "ascensore":
                                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                                break;
                                                            case "montauto":
                                                                name_1 = item.nome + " - " + item.numeroMatricola;
                                                                break;
                                                            case "contatoriAcqua":
                                                                name_1 = item.nome + " - " + item.codiceUtente;
                                                                break;
                                                            // case "estintori":
                                                            //   name = "Estintori";
                                                            //   break;
                                                        }
                                                        var selStructure_1 = {
                                                            id: item._id,
                                                            name: name_1,
                                                            value: false,
                                                            type: structure_2,
                                                        };
                                                        // Prevent duplicate insert
                                                        if (ids.includes(selStructure_1.id)) {
                                                            subEl = tslib_1.__assign({}, subEl, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_1.type; }) });
                                                            return;
                                                        }
                                                        _this.structureSelected.push(selStructure_1);
                                                        subEl = tslib_1.__assign({}, subEl, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === selStructure_1.type; }) });
                                                    }
                                                });
                                            }
                                            else {
                                                // vvFdefinitivo
                                                if (title_1 === "vvFdefinitivo") {
                                                    if (_this.documentArchive.vvFdefinitivo &&
                                                        Array.isArray(_this.documentArchive.vvFdefinitivo)) {
                                                        _this.documentArchive.vvFdefinitivo.forEach(function (item) {
                                                            // Skip structures whose documents were all deleted.
                                                            // A structure with no document history yet (e.g. just created)
                                                            // must NOT be treated as deleted, otherwise it never becomes
                                                            // selectable and its structureObjectType/Name/Id can't be set.
                                                            var structureDeleted = false;
                                                            if (item && item.documents) {
                                                                for (var key_1 in item.documents) {
                                                                    var docs_1 = item.documents[key_1];
                                                                    if (Array.isArray(docs_1) && docs_1.length) {
                                                                        if (docs_1.some(function (doc) { return !doc.deleted; })) {
                                                                            structureDeleted = false;
                                                                            break;
                                                                        }
                                                                        structureDeleted = true;
                                                                    }
                                                                }
                                                            }
                                                            if (item.structureObjectType !== "" && !structureDeleted) {
                                                                var ids = _this.structureSelected.map(function (el) { return el.id; });
                                                                var structure_3 = {
                                                                    id: item.structureObjectId,
                                                                    name: item.structureObjectName,
                                                                    value: false,
                                                                    type: "vvFdefinitivo",
                                                                    typeStructure: item.structureObjectType,
                                                                };
                                                                // Prevent duplicate insert
                                                                if (ids.includes(structure_3.id)) {
                                                                    subEl = tslib_1.__assign({}, subEl, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === structure_3.type; }) });
                                                                    return;
                                                                }
                                                                _this.structureSelected.push(structure_3);
                                                                subEl = tslib_1.__assign({}, subEl, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === structure_3.type; }) });
                                                            }
                                                        });
                                                    }
                                                    if (_this.condoStructure.attivitavvf &&
                                                        Array.isArray(_this.condoStructure.attivitavvf)) {
                                                        var attivitavvf = _this.condoStructure.attivitavvf.filter(function (el) {
                                                            return !_this.structureSelected.find(function (subEl) {
                                                                return subEl.id &&
                                                                    el._id &&
                                                                    subEl.id.toString() === el._id.toString();
                                                            });
                                                        });
                                                        try {
                                                            for (var attivitavvf_1 = (e_3 = void 0, tslib_1.__values(attivitavvf)), attivitavvf_1_1 = attivitavvf_1.next(); !attivitavvf_1_1.done; attivitavvf_1_1 = attivitavvf_1.next()) {
                                                                var item = attivitavvf_1_1.value;
                                                                _this.structureSelected.push({
                                                                    id: item._id,
                                                                    name: item.nome,
                                                                    value: false,
                                                                    type: 'vvFdefinitivo',
                                                                    typeStructure: 'attivitavvf'
                                                                });
                                                            }
                                                        }
                                                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                                        finally {
                                                            try {
                                                                if (attivitavvf_1_1 && !attivitavvf_1_1.done && (_a = attivitavvf_1.return)) _a.call(attivitavvf_1);
                                                            }
                                                            finally { if (e_3) throw e_3.error; }
                                                        }
                                                        subEl = tslib_1.__assign({}, subEl, { structureSelected: _this.structureSelected.filter(function (el) { return el.type === 'vvFdefinitivo'; }) });
                                                    }
                                                }
                                            }
                                            return "break";
                                        }
                                    }
                                }
                            };
                            try {
                                for (var _b = tslib_1.__values(_this.documentTemplate), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var docs = _c.value;
                                    var state_2 = _loop_2(docs);
                                    if (state_2 === "break")
                                        break;
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        _this.docsSelected.push({
                            subDoc: title_1,
                            subAreaTitle: subEl.subAreaTitle,
                            title: subEl.title,
                            key: key,
                            schemaType: subEl.schemaType,
                            structureSelected: subEl.structureSelected,
                        });
                        structures = true;
                    }
                    // Sort displayed data in alphabetical order
                    // this.docsSelected.sort((a, b) => a.code.localeCompare(b.code));
                });
            });
        }
        if (this.structureSelected.length) {
            this.canSubmitForm = false;
        }
        else {
            this.canSubmitForm = true;
        }
        this.initForm(key, schemaType);
    };
    /**
     * init form
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.initForm = function (documentKey, schemaType) {
        var _this = this;
        // Reset fields and form controls
        this.fields = [];
        var formControlKeys = Object.keys(this.form.controls);
        if (formControlKeys.length) {
            formControlKeys.forEach(function (key) {
                _this.form.removeControl(key);
            });
        }
        this.options.formState = {
            disabled: false,
        };
        // create default field to formly
        var defaultFields = [
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3
                },
            }
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(
        //   documentKey,
        //   false
        // );
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        aryfields.forEach(function (item) {
            if (item.templateOptions && item.templateOptions.placeholder) {
                item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
            }
            if (item.type === "select") {
                if (Array.isArray(item.templateOptions.options)) {
                    item.templateOptions.options.forEach(function (subItem) {
                        subItem.label = _this.translateService.instant(subItem.label);
                    });
                }
            }
            if (item.type === "selectNew") {
                item.type = "autocomplete";
                if (item.templateOptions.initialValues) {
                    var options_1 = [];
                    switch (item.templateOptions.initialValues) {
                        case "suppliersName":
                            _this.suppliersName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "yearsOfStorage":
                            _this.yearsOfStorage.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "conductorName":
                            _this.conductorName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "nameInterventionArchiving":
                            _this.nameInterventionArchiving.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                    }
                    item.templateOptions.initialValues = options_1;
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    var requiredAsterisk = "";
                    if (item.templateOptions.required) {
                        requiredAsterisk = "";
                    }
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel) + " " + requiredAsterisk;
                }
            }
            if (item.type === "autocomplete" ||
                item.type === "autocomplete-supplier") {
                var requiredAsterisk = "";
                if (item.templateOptions.required) {
                    requiredAsterisk = "";
                }
                item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel) + " " + requiredAsterisk;
                if (item.templateOptions.search$ === "suppliersService") {
                    item.templateOptions.search$ =
                        _this.suppliersService.getListV2.bind(_this);
                }
            }
            else {
                if (item.templateOptions && item.templateOptions.label) {
                    item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                }
            }
        });
        var fieldGroup = aryfields.concat(defaultFields);
        var itemConfig = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        this.fields = itemConfig;
        if (this.docType && this.docType === "digital") {
            this.fields.push({
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        type: "file-uploader",
                        key: "documentFile",
                        templateOptions: {
                            required: true,
                            allowedFilesNumber: 200,
                            allowedFilesExtensions: this.configService.allowedDocumentExtensions,
                            customLabel: this.translateService.instant("properties.detail.documentArchive.fields.file"),
                        },
                    },
                ],
            });
        }
        else if (this.docType && this.docType === "paper") {
            // For better fields displaying
            // this.dialogRef.updateSize('60vw');
            this.fields.push({
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-6",
                        type: "input",
                        key: "numFiles",
                        hooks: {
                            onInit: function (field) {
                                field.formControl.valueChanges
                                    .pipe(tap(function (value) {
                                    if (typeof value === "undefined") {
                                        value = null;
                                    }
                                    if (value > field.templateOptions.max) {
                                        value = field.templateOptions.max;
                                    }
                                    if (_this.model.files) {
                                        _this.model.files.length = value;
                                    }
                                    _this.model = tslib_1.__assign({}, _this.model, { numFiles: value });
                                }))
                                    .subscribe();
                            },
                        },
                        templateOptions: {
                            type: "number",
                            label: this.translateService.instant("properties.detail.documentArchive.fields.numFiles"),
                            required: false,
                            min: 2,
                            max: 100,
                        },
                        expressionProperties: {
                            // apply expressionProperty for disabled based on formState
                            "templateOptions.disabled": "formState.disabled",
                        },
                    },
                    {
                        className: "docs-radio-group-wrapper col-12",
                        key: "files",
                        type: "repeat",
                        expressionProperties: {
                            // apply expressionProperty for disabled based on formState
                            "templateOptions.disabled": "formState.disabled",
                        },
                        fieldArray: {
                            fieldGroup: [
                                {
                                    className: "pl-0 col-12 col-md-6",
                                    type: "input",
                                    key: "name",
                                    hooks: {
                                        onInit: function (field) {
                                            var type = field.parent.fieldGroup[1].defaultValue[0]; // take first letter from radio's defaultValue
                                            var name = this.barCode; // barcode value
                                            var index = +field.parent.key + 1; // actual array index plus 1
                                            field.defaultValue =
                                                (name + "_" + type + index).toUpperCase();
                                        },
                                    },
                                    templateOptions: {
                                        label: this.translateService.instant("properties.detail.documentArchive.fields.name"),
                                        placeholder: this.translateService.instant("properties.detail.documentArchive.fields.name"),
                                        minLength: 0,
                                        maxLength: 500,
                                        readonly: true,
                                    },
                                },
                                {
                                    className: "col-12 col-md-6",
                                    type: "radio",
                                    key: "docType",
                                    defaultValue: "report",
                                    expressionProperties: {
                                        "templateOptions.onChange": function (model, opt, field) {
                                            if (model) {
                                                var position = +field.parent.key;
                                                // @todo: da rivedere (segnalato in #105)
                                                // Return if no changes were made
                                                // if (
                                                //   this.previousDocTypes.map(el => el.value).includes(field.formControl.value)
                                                //   && this.previousDocTypes.map(el => el.position).includes(position)
                                                // ) {
                                                //   return;
                                                // }
                                                // this.previousDocTypes = [];
                                                // field.parent.parent.fieldGroup.forEach(el => {
                                                //   this.previousDocTypes.push({
                                                //     position,
                                                //     value: el.formControl.value.docType
                                                //   });
                                                // });
                                                var type = model.docType[0]; // take first letter from radio's actual value
                                                var name_2 = _this.barCode; // barcode value
                                                var index = position + 1; // actual array index plus 1;
                                                // Set new value in model
                                                model.name = (name_2 + "_" + type + index).toUpperCase();
                                                // Set new value in field (make it change inside form input)
                                                field.parent.fieldGroup[0].formControl.setValue(model.name);
                                            }
                                        },
                                    },
                                    templateOptions: {
                                        label: this.translateService.instant("properties.detail.documentArchive.fields.docType"),
                                        options: [
                                            {
                                                value: "report",
                                                label: this.translateService.instant("properties.detail.documentArchive.fields.report"),
                                            },
                                            {
                                                value: "tables",
                                                label: this.translateService.instant("properties.detail.documentArchive.fields.tables"),
                                            },
                                            {
                                                value: "calcs",
                                                label: this.translateService.instant("properties.detail.documentArchive.fields.calcs"),
                                            },
                                            {
                                                value: "schemas",
                                                label: this.translateService.instant("properties.detail.documentArchive.fields.schemas"),
                                            },
                                            {
                                                value: "various",
                                                label: this.translateService.instant("properties.detail.documentArchive.fields.various"),
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            });
        }
        else {
            this.toastrService.error("Error: no docType selected");
        }
    };
    /**
     * Enable/Disable docs depend on inserted structure
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.setVisibleDocsByStructures = function () {
        var _this = this;
        // Check "unitaImmobiliari"
        this.unitaImmobiliari = false;
        var ui = this.documentTemplate.find(function (docs) {
            return docs.group === "unitaImmobiliari";
        });
        if (ui && ui.content && Array.isArray(ui.content)) {
            this.unitaImmobiliari = ui.content.some(function (subDoc) {
                var title = subDoc.title.replace("properties.documents.", "");
                if (_this.documentArchive[title] && _this.documentArchive[title].length) {
                    return true;
                }
            });
        }
        this.dataIsLoading = false;
        if (this.docArea &&
            this.docArea.content &&
            Array.isArray(this.docArea.content)) {
            var allSubElementsVisible_1 = false;
            this.docArea.content.forEach(function (el) {
                if (el.content && Array.isArray(el.content)) {
                    allSubElementsVisible_1 = false;
                    el.content.forEach(function (subEl) {
                        var e_4, _a, e_5, _b, e_6, _c;
                        var title = subEl.title.replace("properties.documents.", "");
                        try {
                            for (var _d = tslib_1.__values(_this.documentTemplate), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var docs = _e.value;
                                if (!docs.deleted) {
                                    var content = docs.content;
                                    if (content && Array.isArray(content)) {
                                        var index = content.findIndex(function (subDocs) {
                                            return (subDocs.title.replace("properties.documents.", "") === title);
                                        });
                                        if (index > -1) {
                                            var structure = content[index].structure;
                                            if (structure && structure !== "") {
                                                if (_this.condoStructure &&
                                                    _this.condoStructure[structure] &&
                                                    Array.isArray(_this.condoStructure[structure]) &&
                                                    _this.condoStructure[structure].length > 0) {
                                                    subEl.visible = true;
                                                    allSubElementsVisible_1 = true;
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else if (title === "impelegenerale") {
                                                if (_this.condoStructure &&
                                                    _this.condoStructure["fornituraBt"] &&
                                                    Array.isArray(_this.condoStructure["fornituraBt"]) &&
                                                    _this.condoStructure["fornituraBt"].length > 0) {
                                                    subEl.visible = true;
                                                    allSubElementsVisible_1 = true;
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else if (title === "impeleMediaTensione") {
                                                if (_this.condoStructure &&
                                                    _this.condoStructure["fornituraMt"] &&
                                                    Array.isArray(_this.condoStructure["fornituraMt"]) &&
                                                    _this.condoStructure["fornituraMt"].length > 0) {
                                                    subEl.visible = true;
                                                    allSubElementsVisible_1 = true;
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else if (title === "sicurezzaAntincendioFacciate") {
                                                if (_this.condoStructure &&
                                                    _this.condoStructure["fabbricatoAbitativo"] &&
                                                    Array.isArray(_this.condoStructure["fabbricatoAbitativo"]) &&
                                                    _this.condoStructure["fabbricatoAbitativo"].length > 0) {
                                                    subEl.visible = false;
                                                    try {
                                                        for (var _f = (e_5 = void 0, tslib_1.__values(_this.condoStructure["fabbricatoAbitativo"])), _g = _f.next(); !_g.done; _g = _f.next()) {
                                                            var fabbricatoAbitativo = _g.value;
                                                            if (fabbricatoAbitativo.altezzaAntincendio !== " " &&
                                                                fabbricatoAbitativo.altezzaAntincendio !== "12<") {
                                                                subEl.visible = true;
                                                                allSubElementsVisible_1 = true;
                                                                _this.isSicurezzaAntincendioFacciate = true;
                                                            }
                                                        }
                                                    }
                                                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                                    finally {
                                                        try {
                                                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                                                        }
                                                        finally { if (e_5) throw e_5.error; }
                                                    }
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else if (title === "incendioEvac") {
                                                if (_this.condoStructure &&
                                                    _this.condoStructure["fabbricatoAbitativo"] &&
                                                    Array.isArray(_this.condoStructure["fabbricatoAbitativo"]) &&
                                                    _this.condoStructure["fabbricatoAbitativo"].length > 0) {
                                                    subEl.visible = false;
                                                    try {
                                                        for (var _h = (e_6 = void 0, tslib_1.__values(_this.condoStructure["fabbricatoAbitativo"])), _j = _h.next(); !_j.done; _j = _h.next()) {
                                                            var fabbricatoAbitativo = _j.value;
                                                            if (fabbricatoAbitativo.altezzaAntincendio === "54< H <=80" ||
                                                                fabbricatoAbitativo.altezzaAntincendio === ">80") {
                                                                subEl.visible = true;
                                                                allSubElementsVisible_1 = true;
                                                                _this.isIncendioEvac = true;
                                                            }
                                                        }
                                                    }
                                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                                    finally {
                                                        try {
                                                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                                        }
                                                        finally { if (e_6) throw e_6.error; }
                                                    }
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else if (title === "vvFdefinitivo") {
                                                if (_this.documentArchive &&
                                                    _this.documentArchive["vvFdefinitivo"] &&
                                                    Array.isArray(_this.documentArchive["vvFdefinitivo"]) &&
                                                    _this.documentArchive["vvFdefinitivo"].length > 0) {
                                                    subEl.visible = true;
                                                    allSubElementsVisible_1 = true;
                                                }
                                                else {
                                                    subEl.visible = false;
                                                }
                                            }
                                            else {
                                                allSubElementsVisible_1 = true;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    });
                    if (_this.subscriptionType !== "FREE" && _this.subscriptionType !== "FREEBASIC") {
                        el.visible = allSubElementsVisible_1;
                    }
                }
            });
        }
    };
    /**
     * Check which structures are selected and then enable submit button
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onChangePlant = function (structure, event) {
        var _this = this;
        if (this.contratti) {
            this.canSubmitForm = true;
            if (this.docsSelected && this.docsSelected.length) {
                this.docsSelected.forEach(function (el) {
                    if (Array.isArray(el.structureSelected) &&
                        el.structureSelected.length) {
                        if (!el.structureSelected.some(function (subEl) { return subEl.value; })) {
                            _this.canSubmitForm = false;
                        }
                    }
                });
            }
        }
        else {
            this.canSubmitForm = false;
            if (this.structureSelected && this.structureSelected.length) {
                if (this.structureSelected.some(function (el) { return el.value; })) {
                    this.canSubmitForm = true;
                }
            }
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            console.warn("form", this.form);
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        // Check NeW property and set correct value
        if (this.form.value) {
            var param_1 = "";
            var val_1 = "";
            Object.keys(this.form.value).forEach(function (key) {
                if (key.substr(-3) === 'NeW' && _this.form.value[key] !== "") {
                    param_1 = key.substr(0, key.length - 3);
                    val_1 = _this.form.value[key];
                }
            });
            if (param_1 !== "") {
                this.form.value[param_1] = val_1;
                delete this.form.value[param_1 + "NeW"];
            }
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        // Only structures selected
        var structureSelected = this.structureSelected.filter(function (el) {
            return el.value;
        });
        var dataToSend = {};
        if (this.form.value) {
            if (this.docType === "digital") {
                dataToSend = {
                    data: this.form.value,
                    docsSelected: this.docsSelected,
                    documentFile: this.form.value.documentFile,
                    contratti: this.contratti,
                };
                if (this.structureSelected.length) {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: structureSelected });
                }
                if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructureFree });
                }
                this.subscriptions.push(this.documentArchivesService
                    .updateMultiDoc(this.documentArchiveId, dataToSend)
                    .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.docUploaded = true;
                        _this.options.formState = {
                            disabled: true,
                        };
                        Object.keys(_this.form.controls).forEach(function (key) {
                            var control = _this.form.controls[key];
                            if (control) {
                                control.disable();
                            }
                        });
                        if (res.data && typeof res.data === "string") {
                            _this.barCode = res.data.toUpperCase();
                        }
                        _this.toastrService.success(res.message);
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }
                }, function (err) {
                    _this.helperService.handleFormlyError(_this.form, err);
                }));
            }
            else if (this.docType === "paper") {
                // First file is not required and name is equal to barcode - 2021-07-10
                if (!this.model.numFiles || !this.model.files) {
                    this.model.numFiles = 1;
                    this.model.files = [{
                            docType: "",
                            name: this.barCode
                        }];
                }
                dataToSend = {
                    data: tslib_1.__assign({}, this.model, { property: this.propertyId, code: this.barCode, area: this.selectedArea }),
                    docsSelected: this.docsSelected,
                    documentFile: this.form.value.documentFile,
                };
                if (this.structureSelected.length) {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.structureSelected });
                }
                if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
                    dataToSend = tslib_1.__assign({}, dataToSend, { structureSelected: this.selectedStructureFree });
                }
                this.subscriptions.push(this.documentArchivesService
                    .updateMultiPaperDoc(this.documentArchive._id, dataToSend)
                    .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.docUploaded = true;
                        _this.options.formState = {
                            disabled: true,
                        };
                        Object.keys(_this.form.controls).forEach(function (key) {
                            var control = _this.form.controls[key];
                            if (control) {
                                control.disable();
                            }
                        });
                        _this.toastrService.success(res.message);
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                    _this.helperService.handleFormlyError(_this.form, err);
                }));
            }
        }
    };
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        // If target is not provided, than just export all properties
        if (!target) {
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list.exportFileName") + " " + date;
            this.subscriptions.push(this.propertiesService.getExport().subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_2 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_2 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Handle insertNew button click
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onRestart = function () {
        var _this = this;
        // Reset data
        this.step0 = true;
        this.step1 = false;
        this.checkboxesAreSelected = false;
        this.docUploaded = false;
        this.selectedArea = undefined;
        this.docArea = this.documentTypeStructure.getDocumentArea2(undefined, this.documentTemplate);
        this.model = {};
        this.docTopics = [];
        this.docSubTopics = [];
        this.selectedSubTopics = [];
        this.docsSelected = [];
        this.docType = undefined;
        // Enable form fields
        Object.keys(this.form.controls).forEach(function (key) {
            var control = _this.form.controls[key];
            if (control) {
                control.enable();
            }
        });
        this.documentArchiveIsLoading = true;
        this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
            if (res.status) {
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                _this.documentArchiveIsLoading = false;
                // Calculate property's barCode - just for Paper doc
                var total = (+_this.propertyData.totalDocsProgressive + 1).toString();
                _this.barCode = _this.propertyData._id + "S" + total.padStart(6, "0") + "C";
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle print file qrCode
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onPrint = function (target) {
        var qrCodes = [];
        if (this.model.files && this.model.files.length) {
            // If we're here we have a paper doc
            this.model.files.forEach(function (file) {
                if (file.name) {
                    qrCodes.push(file.name);
                }
            });
        }
        else if (this.model.documentFile && this.model.documentFile.length) {
            // If we're here we have a digital doc
            qrCodes.push(this.barCode);
        }
        else {
            // Paper doc: First file is not required and name is equal to barcode - 2021-07-10
            qrCodes.push(this.barCode);
        }
        if (!qrCodes.length) {
            this.toastrService.error("No qrCodes to inject");
            return;
        }
        var data;
        if (target === "qr") {
            data = {
                target: target,
                qrCodes: qrCodes,
                propertyName: this.propertyData.name,
                propertyCity: this.propertyData.address.city,
                propertyAddress: this.propertyData.address.route + ", " + this.propertyData.address.streetNumber,
                area: this.selectedArea,
                docs: this.docsSelected,
            };
        }
        else if (target === "module") {
            data = {
                target: target,
                qrCodes: qrCodes,
                propertyName: this.propertyData.name,
                propertyCity: this.propertyData.address.city,
                propertyAddress: this.propertyData.address.route + ", " + this.propertyData.address.streetNumber,
                area: this.selectedArea,
                uploadDate: new Date(),
                content: this.model.contenutoDocumento,
                docs: this.docsSelected,
                structures: this.structureSelected.length
                    ? this.structureSelected.filter(function (el) { return el.value; })
                    : undefined,
            };
        }
        else {
            this.toastrService.error("missing print target");
        }
        // Open dialog
        this.dialog.open(PrintQrDialogComponent, {
            data: data,
            width: "600px"
        });
    };
    /**
     * Convert image into Base64
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.convertBase64ToBlob = function (Base64Image) {
        // SPLIT INTO TWO PARTS
        var parts = Base64Image.split(";base64,");
        // HOLD THE CONTENT TYPE
        var imageType = parts[0].split(":")[1];
        // DECODE BASE64 STRING
        var decodedData = window.atob(parts[1]);
        // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
        var uInt8Array = new Uint8Array(decodedData.length);
        // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
        for (var i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // RETURN BLOB IMAGE AFTER CONVERSION
        return new Blob([uInt8Array], { type: imageType });
    };
    /**
     * Prevent redirect to archive if structure is open
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onGoToDocumentArchive = function () {
        if (!this.mappaturaOpen) {
            return;
        }
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.mappaturaOpen.title'),
                message: this.translateService.instant('dialogs.confirm.mappaturaOpen.message'),
                btnCancelText: this.translateService.instant('common.cta.close'),
                messageOnly: true,
            },
            width: '500px',
            disableClose: false,
        });
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onExportContracts = function () {
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    PropertyAddDocumentsComponent.prototype.onExportRAS = function () {
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    return PropertyAddDocumentsComponent;
}());
export { PropertyAddDocumentsComponent };
